module.exports = __webpack_public_path__ + "img/img-classify6.5379ffe3.png";